import React from 'react';
import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';
import {InputText} from 'primereact/inputtext';
const changePassword = (props) =>{

    let isEnabled = (props.password!=='') &&  (props.confirmPassword!=='') 

    const dialogFooter = (
        <div>
            <Button icon="pi pi-times" onClick={props.clearPassword} label="Cancel" className="p-button-secondary" />
            <Button disabled={!isEnabled} className="p-button-primary"  icon="pi pi-check" onClick={props.changePassword} label="Save" />
        </div>
    )

    return (
        <Dialog header="Change Password" visible={true} modal={true} style={{width: '50vw'}} footer={dialogFooter} onHide={props.clearPassword} blockScroll >
            <h5 style={{marginTop:'1px'}}>Password <span className="requiredColor">(Min 6 Digits)</span></h5>
            <span className="p-float-label">
                <InputText type="password" className="p-col-12" placeholder="Enter Password" value={props.password} name="password" onChange={props.change} />
            </span>
            <h5>Confirm Password</h5>
            <span className="p-float-label">
                <InputText type="password" className="p-col-12" placeholder="Enter Confirm Password" value={props.confirmPassword} name="confirmPassword" onChange={props.change} />
            </span>
        </Dialog>
    )

}

export default changePassword;